import { useEffect, useState } from "react";

import { getPosts } from "../services/post.service";
import type { Post } from "../types/post.types";

export default function usePosts() {

  const [posts, setPosts] = useState<
    Post[]
  >([]);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {

    const fetchPosts = async () => {
      try {
        const data =
          await getPosts();

        setPosts(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();

  }, []);

  return {
    posts,
    loading,
  };
}